<div
  [onyxDropdownOptions]="options()"
  [onyxDropdownAttached]="attached()"
  [onyxDropdownPositions]="[OnyxOverlayPosition.RIGHT]"
  [onyxDropdownOverridePositions]="{
    offsetX: -4,
    originY: 'top',
    overlayY: 'top',
  }"
  (onyxDropdownSelectedValueChange)="$event.value?.(coordinates())"
  (onyxDropdownAttachedChange)="!$event ? close()() : null"
></div>
